import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  IsActiveMatchOptions,
  QueryParamsHandling,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { IconComponent, IconShape } from '@copado/cds';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

export interface NavItem {
  id?: string;
  icon: IconShape;
  label: string;
  new?: boolean;
  routerLink?: string;
  queryParams?: Record<string, string>;
  routerOptions:
    | IsActiveMatchOptions
    | {
        exact: boolean;
      };
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
  imports: [NgbTooltip, IconComponent, RouterLink, RouterLinkActive],
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
})
export class NavItemComponent {
  item = input.required<NavItem>();
  isCollapsed = input(false);
  queryParamsHandling = input<QueryParamsHandling>('');
}
